import type {
  ListRoutingBreakersResponse,
  ResetRoutingBreakerRequest,
  ResetRoutingBreakerResponse,
  RoutingBreakerSettingsResponse,
  TripRoutingBreakerRequest,
  TripRoutingBreakerResponse,
  UpdateRoutingBreakerSettingsRequest,
  UpdateRoutingBreakerSettingsResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

/**
 * Routing circuit-breaker control plane (epic #886 PR-6): list the
 * currently open / half-open / force-opened target identities, force-close
 * (reset) and force-open (trip) them. Backed by ops-api's
 * `/v1/ops/routing-breakers` proxy — every mutation is audited server-side.
 */

const BASE = '/v1/ops/routing-breakers';

export async function listRoutingBreakers(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListRoutingBreakersResponse> {
  return opsApiRequest<ListRoutingBreakersResponse>(BASE, { signal }, fetchImpl);
}

export async function resetRoutingBreaker(
  body: ResetRoutingBreakerRequest,
  fetchImpl: typeof fetch,
): Promise<ResetRoutingBreakerResponse> {
  return opsApiRequest<ResetRoutingBreakerResponse>(
    `${BASE}/reset`,
    { method: 'POST', body },
    fetchImpl,
  );
}

export async function tripRoutingBreaker(
  body: TripRoutingBreakerRequest,
  fetchImpl: typeof fetch,
): Promise<TripRoutingBreakerResponse> {
  return opsApiRequest<TripRoutingBreakerResponse>(
    `${BASE}/trip`,
    { method: 'POST', body },
    fetchImpl,
  );
}

export async function getRoutingBreakerSettings(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<RoutingBreakerSettingsResponse> {
  return opsApiRequest<RoutingBreakerSettingsResponse>(`${BASE}/settings`, { signal }, fetchImpl);
}

export async function updateRoutingBreakerSettings(
  body: UpdateRoutingBreakerSettingsRequest,
  fetchImpl: typeof fetch,
): Promise<UpdateRoutingBreakerSettingsResponse> {
  return opsApiRequest<UpdateRoutingBreakerSettingsResponse>(
    `${BASE}/settings`,
    { method: 'PUT', body },
    fetchImpl,
  );
}
